import { render, staticRenderFns } from "./RecoverPasswordRequest.vue?vue&type=template&id=5d97e13a&scoped=true&lang=pug&"
import script from "./RecoverPasswordRequest.vue?vue&type=script&lang=js&"
export * from "./RecoverPasswordRequest.vue?vue&type=script&lang=js&"
import style0 from "./RecoverPasswordRequest.vue?vue&type=style&index=0&id=5d97e13a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d97e13a",
  null
  
)

export default component.exports